import { Label } from "components/Label";
import { Vertical } from "gls/lib";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { classes, media, style } from "typestyle";
import { Error } from "../Error";
import { colours } from "styling/colours";
import { MOBILEDEVICEWIDTH } from "config/constants";
import { inputStyle } from "./Input/BaseInput";

type TextAreaProps = {
  value: string;
  onChange: (v: string) => void;
  maxLength?: number;
  id?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  preventNewLine?: boolean;
  width?: string;
  maxWidth?: string;
  rows?: number;
  error?: string;
};

export const TextArea = (props: TextAreaProps) => {
  const {
    maxLength,
    value,
    width = "100%",
    maxWidth = "625px",
    rows,
    error,
    ariaLabel = "textarea",
    id = ariaLabel,
  } = props;
  const [charactersLeft, setCharactersLeft] = useState(maxLength || Infinity);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (props.preventNewLine && e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
    if (maxLength && (value?.length || 0) + 1 > maxLength) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      return props.onChange(e.target.value.substring(0, maxLength));
    }
    props.onChange(e.target.value);
  };

  useEffect(() => {
    if (maxLength) {
      setCharactersLeft(maxLength - (value?.length || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxLength, value])

  return (
    <Vertical
      spacing={0}
      className={classes(
        style({ width: width, maxWidth: maxWidth, position: "relative" }),
        props.className
      )}
      id={ariaLabel}
    >
      {props.label && (
        <Label
          htmlFor={props.name}
          value={props.label}
          required={props.required}
          id={`${id}-label`}
        />
      )}
      <textarea
        rows={rows}
        value={value}
        onKeyDown={handleKeyPress}
        aria-labelledby={`${id}-label`}
        onChange={handleChange}
        name={props.name}
        disabled={props.disabled}
        placeholder={props.placeholder}
        className={classes(inputStyle, textAreaStyle(rows, error))}
        aria-label={`${ariaLabel} Input`}
        id={id}
      />
      {props.maxLength && (
        <div
          className={maxLengthStyle}
          aria-label="textAreaContent"
          id={`${ariaLabel} Content`}
        >
          {charactersLeft}
        </div>
      )}
      {error && (
        <Error id={`${props.name}-error`} message={error} />
      )}
    </Vertical>
  );
};

const textAreaStyle = (rows: number | undefined, error?: string) => style(
  {
    resize: "none",
    height: rows !== undefined ? 'auto' : "140px",
    borderColor: isEmpty(error) ? "auto" : colours.error
  },
  media({ maxWidth: MOBILEDEVICEWIDTH }, { fontSize: 13 })
);

const maxLengthStyle = style({
  position: "absolute",
  bottom: '0px',
  right: '7px',
  lineHeight: "24px",
  fontSize: "12px",
  color: colours.secondaryText,
})